import { useAccount } from "wagmi";
import { NavLink } from "react-router-dom";
import * as S from "./MyProfileNav.styled";

import {
  KycStatus,
  Typography,
  Button,
  // NewLabel,
} from "../../../../components";
import { routes } from "../../../../utils/routes";
import { useAuth, useProtocolSettingsAddress } from "../../../../hooks";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { getUserData } from "../../../../redux/features/userSlice";

interface MyProfileNavProps {
  click?: () => void;
}

const MyProfileNav = ({ click }: MyProfileNavProps) => {
  const isLogged = useAppSelector((state) => state.user.isLogged);
  const dispatch = useAppDispatch();
  const { logout } = useAuth();
  const { chainId } = useAccount();
  const protocolSettingsAddress = useProtocolSettingsAddress();
  const kycType = useAppSelector((store) => store.user.userData?.kyc?.kycType);

  const handleKycClick = () => {
    if (!chainId) return;
    const getUserDataPayload = {
      chainId,
      protocolSettingsAddress,
    };

    dispatch(getUserData(getUserDataPayload)).unwrap();
  };
  return (
    <>
      <NavLink onClick={click} to={routes.userPanel.kyc}>
        <S.UserToolElement>
          <Typography.Body
            fontWeight={400}
            opacity={0.92}
            onClick={handleKycClick}
          >
            {kycType === "COMPANY"
              ? "KYB"
              : kycType === "INDIVIDUAL"
              ? "KYC"
              : "KYC/KYB"}
          </Typography.Body>
          <KycStatus />
        </S.UserToolElement>
      </NavLink>
      <NavLink onClick={click} to={routes.userPanel.settings}>
        <S.UserToolElement>
          <Typography.Body fontWeight={400} opacity={0.92}>
            Settings
          </Typography.Body>
        </S.UserToolElement>
      </NavLink>
      {/* <NavLink to={routes.userPanel.referrals}>
        <S.UserToolElement>
          <Typography.Body fontWeight={400} opacity={0.92}>
            Referrals
          </Typography.Body>
          <NewLabel />
        </S.UserToolElement>
      </NavLink> */}
      {isLogged && (
        <Button.Secondary type="button" onClick={() => logout()}>
          Logout
        </Button.Secondary>
      )}
    </>
  );
};

export default MyProfileNav;
